import React, { useState, useEffect } from 'react';
import './PasswordGate.css';
import { getApiBaseUrl } from '../config';

// Session is valid for 1 hour
const SESSION_DURATION_MS = 1 * 60 * 60 * 1000;

function PasswordGate({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading]             = useState(true);
  const [password, setPassword]               = useState('');
  const [error, setError]                     = useState('');

  useEffect(() => {
    checkAccess();
  }, []);

  const checkAccess = async () => {
    // 1. Ask the server if a password is even required.
    //    When SITE_PASSWORD_HASH is blank in .env we don't need it
    try {
      const response = await fetch(`${getApiBaseUrl()}/api/site-password`, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ password: '' }),
      });
      const data = await response.json();

      if (data.success) {
        // No password configured server-side, grant access immediately
        setIsAuthenticated(true);
        setIsLoading(false);
        return;
      }
    } catch (e) {
      // Server unreachable, fall through and check local session
      console.warn('[PasswordGate] Could not reach server:', e.message);
    }

    // 2. Server requires a password, check for a valid unexpired local session
    const authenticated   = localStorage.getItem('siteAuthenticated');
    const authenticatedAt = parseInt(localStorage.getItem('siteAuthenticatedAt') || '0', 10);

    if (authenticated === 'true' && (Date.now() - authenticatedAt) < SESSION_DURATION_MS) {
      setIsAuthenticated(true);
    } else {
      // Clear any stale session
      localStorage.removeItem('siteAuthenticated');
      localStorage.removeItem('siteAuthenticatedAt');
    }

    setIsLoading(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const response = await fetch(`${getApiBaseUrl()}/api/site-password`, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ password }),
      });
      const data = await response.json();

      if (response.ok && data.success) {
        localStorage.setItem('siteAuthenticated',   'true');
        localStorage.setItem('siteAuthenticatedAt', Date.now().toString());
        setIsAuthenticated(true);
        setPassword('');
      } else {
        setError(data.error || 'Incorrect password');
        setPassword('');
      }
    } catch (err) {
      console.error('[PasswordGate] Validation error:', err);
      setError('Connection error — please try again');
      setPassword('');
    }
  };

  // Return null while checking, prevents a flash of the password form
  // on environments where no password is required
  if (isLoading) return null;

  if (!isAuthenticated) {
    return (
      <div className="password-gate">
        <div className="password-gate-container">
          <div className="password-gate-content">
            <h1>Tytonvoice Demo</h1>
            <p>This site is password protected</p>
            <form onSubmit={handleSubmit}>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
                autoFocus
              />
              <button type="submit">Enter</button>
            </form>
            {error && <p className="error">{error}</p>}
          </div>
        </div>
      </div>
    );
  }

  return children;
}

export default PasswordGate;